import {ref} from "vue";
import _ from "lodash";

export function useProducts() {
    const products = ref([]);
    const loading = ref(false);

    function onSearch(search) {
        if (search.length) {
            loading.value = true;

            searchProducts(search);
        }
    }

    const searchProducts = _.debounce(async (search) => {
        const response = await axios.get(route("api.products.search"), {
            params: {
                search: search
            }
        });

        products.value = response.data;
        loading.value = false;
    }, 350);

    return {
        products,
        loading,
        onSearch,
        searchProducts
    };
}
